

export default {
  name: "lineStyle",
  nickname: "线条样式",
  desc: "lineStyle",
  type: "object",
  props: {
    color: {
      name: "color",
      nickname: "颜色",
      desc: "分隔线颜色，可以设置成单个颜色。",
      value: ["#ccc"],
      defaultValue: ["#ccc"],
      type: "pureValue",
      eType: "color",
    },
    width: {
      name: "width",
      nickname: "宽度",
      desc: "分隔线线宽。",
      value: 1,
      defaultValue: 1,
      type: "pureValue",
    },
    type: {
      name: "type",
      nickname: "类型",
      desc: "分隔线线的类型。",
      value: "solid",
      defaultValue: "solid",
      type: "pureValue",
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc:
        '图形阴影的模糊大小。该属性配合 <code class="codespan">shadowColor</code>,<code class="codespan">shadowOffsetX</code>, <code class="codespan">shadowOffsetY</code> 一起设置图形的阴影效果。',
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: '阴影颜色。支持的格式同<code class="codespan">color</code>。',
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "阴影水平方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "阴影垂直方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    opacity: {
      name: "opacity",
      nickname: "透明度",
      desc: "图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。",
    },
  },
}
